<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>禁用学生列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="注册时间：">
              <Date-picker  v-model="regDateRange" format="yyyy-MM-dd" type="daterange"
                            placement="bottom-start" placeholder="选择日期"
                            @on-change="regDateChange" style="width: 100%;"></Date-picker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导：">
              <Input name="studyAdviserName" v-model="queryParam.studyAdviserName" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问：">
              <Input name="adviserName" v-model="queryParam.adviserName" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学员ID：">
              <Input name="uid" v-model="queryParam.uid" placeholder="不支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生姓名：">
              <Input name="nickname" v-model="queryParam.nickname" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学生手机号：">
              <Input name="mobile" v-model="queryParam.mobile" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </Col>
          <Col :span="2">
            <Form-item>
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                      @click="search" >搜索</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/user/notAllowed/list"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
  import dates from '@/tools/date/dates.js'
  export default {
    name: 'UserRefundList',
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        queryParam: {
          startTime: null,
          endTime: null,
          uid: '',
          adviserName: '',
          nickname: '',
          mobile: '',
          studyAdviserName: '',
          status: 0
        },
        regDateRange: [],
        title: [
          {
            title: '学生ID/姓名',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.id + '-' + row.nickname)
            }
          },
          {
            title: '手机号',
            // width: 130,
            align: 'center',
            key: 'mobile',
            render: (h, params) => {
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '学导',
            // width: 130,
            align: 'center',
            key: 'studyAdviserName'
          },
          {
            title: '课程顾问',
            // width: 130,
            align: 'center',
            key: 'adviserName'
          },
          {
            title: '注册渠道',
            // width: 120,
            align: 'center',
            key: 'regType',
            // render: (h, params) => {
            //   let regType = params.row.regType
            //   let canalEnum = $constant.getEnum($constant.studentCanal, regType)
            //   return h('div', canalEnum && canalEnum.text)
            // }
          },
          {
            title: '注册时间',
            align: 'center',
            width: 170,
            key: 'gmtCreate',
          },
          {
            title: '等级',
            // width: 120,
            align: 'center',
            key: 'levelTitle'
          },
          {
            title: '是否付款',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let isPay = params.row.isPay
              let isPayEnum = $constant.getEnum($constant.yesNoNum, isPay)
              return h('span', isPayEnum && isPayEnum.text)
            }
          },
          {
            title: '用户状态',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.userListStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '资源状态',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let resourceStatus = params.row.resourceStatus
              let resourceStatusEnum = $constant.getEnum($constant.resourceStatus, resourceStatus)
              return h('span', resourceStatusEnum && resourceStatusEnum.text)
            }
          },
          {
            title: '学生状态',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let studentStatus = params.row.studentStatus
              let studentStatusEnum = $constant.getEnum($constant.studentStatus, studentStatus)
              return h('span', studentStatusEnum && studentStatusEnum.text)
            }
          },
          {
            title: '学员状态',
            // width: 100,
            align: 'center',
            render: (h, params) => {
              let stdStatus = params.row.stdStatus
              let stdStatusEnum = $constant.getEnum($constant.stdStatus, stdStatus)
              return h('span', stdStatusEnum && stdStatusEnum.text)
            }
          }
        ]
      }
    },
    mounted: function () {
      this.init()
    },
    created: function () {
      this.init()
    },
    methods: {
      init () {
        let query = this.$route.query
        if (query) {
          if (query.startTime) {
            this.regDateRange[0] = dates.format(parseInt(query.startTime) * 1000, 'YYYY-MM-DD') + ''
          }
          if (query.endTime) {
            this.regDateRange[1] = dates.format(parseInt(query.endTime) * 1000, 'YYYY-MM-DD') + ''
          }
          if (query.uid) {
            this.queryParam.uid = query.uid
          }
          if (query.adviserName) {
            this.queryParam.adviserName = query.adviserName
          }
          if (query.studyAdviserName) {
            this.queryParam.studyAdviserName = query.studyAdviserName
          }
          if (query.nickname) {
            this.queryParam.nickname = query.nickname
          }
          if (query.mobile) {
            this.queryParam.mobile = query.mobile
          }
        }
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      regDateChange (dateRange) {
        if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
          let startTime = new Date(new Date(dateRange[0]).toLocaleDateString()).getTime()
          let endTime = new Date(new Date(dateRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          this.queryParam.startTime = parseInt(startTime / 1000)
          this.queryParam.endTime = parseInt(endTime / 1000)
        } else {
          this.queryParam.startTime = null
          this.queryParam.endTime = null
          this.regDateRange = []
        }
        this.search()
      },
    }
  }
</script>



// WEBPACK FOOTER //
// UserNotAllowedList.vue?637f347f